import api from './client'

export const agentesApi = {
  listar: (params = {}) => api.get('/rrhh/agentes', { params }),
  crear: (data) => api.post('/rrhh/agentes', data),
  actualizar: (id, data) => api.put(`/rrhh/agentes/${id}`, data),
  eliminar: (id) => api.delete(`/rrhh/agentes/${id}`),
}

export const pagadoresApi = {
  listar: () => api.get('/rrhh/sueadic/pagadores'),
  crear: (data) => api.post('/rrhh/sueadic/pagadores', data),
  actualizar: (id, data) => api.put(`/rrhh/sueadic/pagadores/${id}`, data),
  eliminar: (id) => api.delete(`/rrhh/sueadic/pagadores/${id}`),
}

export const sueadicApi = {
  // períodos / meses
  periodos: () => api.get('/rrhh/sueadic/periodos'),
  crearPeriodo: (anio, mes, etiqueta) => api.post('/rrhh/sueadic/periodos', { anio, mes, etiqueta }),
  renombrarPeriodo: (id, anio, mes, etiqueta) => api.put(`/rrhh/sueadic/periodos/${id}`, { anio, mes, etiqueta }),
  eliminarPeriodo: (id) => api.delete(`/rrhh/sueadic/periodos/${id}`),
  cerrar: (id) => api.post(`/rrhh/sueadic/periodos/${id}/cerrar`),
  reabrir: (id) => api.post(`/rrhh/sueadic/periodos/${id}/reabrir`),
  vaciar: (id) => api.post(`/rrhh/sueadic/periodos/${id}/vaciar`),
  minuta: (id) => api.get(`/rrhh/sueadic/periodos/${id}/minuta`),
  // tablero del mes
  tablero: (id) => api.get(`/rrhh/sueadic/periodos/${id}/tablero`),
  guardar: (id, filas) => api.post(`/rrhh/sueadic/periodos/${id}/tablero`, { filas }),
  cargarNetos: (id, texto) => api.post(`/rrhh/sueadic/periodos/${id}/netos`, { texto }),
  // Guardar conceptos adicionales por pagador del mes (reemplazo total)
  guardarAdicionales: (id, adicionales) => api.post(`/rrhh/sueadic/periodos/${id}/adicionales`, { adicionales }),
  // Guardar compensaciones de terceros del mes (reemplazo total)
  guardarCompensaciones: (id, compensaciones) => api.post(`/rrhh/sueadic/periodos/${id}/compensaciones`, { compensaciones }),
  // Importación masiva del tablero base de coeficientes (legajo+nombre+coef)
  importarAcuerdos: (texto) => api.post('/rrhh/sueadic/acuerdos/importar', { texto }),
  // Vaciar el tablero base (borra todos los acuerdos + ajustes)
  vaciarTablero: () => api.delete('/rrhh/sueadic/acuerdos'),
  // Estadísticas históricas: grilla legajo × período con banco/extra/total
  estadisticas: () => api.get('/rrhh/sueadic/estadisticas'),
}

export const bonusApi = {
  acuerdos: () => api.get('/rrhh/bonus/acuerdos'),
  acuerdo: (id) => api.get(`/rrhh/bonus/acuerdos/${id}`),
  eventosDisponibles: (id) => api.get(`/rrhh/bonus/acuerdos/${id}/eventos-disponibles`),
  liquidar: (id, data) => api.post(`/rrhh/bonus/acuerdos/${id}/liquidaciones`, data),
  anular: (liqId, motivo) => api.post(`/rrhh/bonus/liquidaciones/${liqId}/anular`, { motivo }),
}
